// app/error.js — Global error boundary
'use client';

import { useEffect } from 'react';
import { FaExclamationTriangle, FaRedo, FaHome } from 'react-icons/fa';

export default function Error({ error, reset }) {
  useEffect(() => {
    console.error('App error:', error);
  }, [error]);

  return (
    <div className="min-h-screen bg-base-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="card bg-base-100 shadow-xl border border-error/20">
          <div className="card-body text-center">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-error/10 rounded-full flex items-center justify-center">
                <FaExclamationTriangle className="text-3xl text-error" />
              </div>
            </div>
            
            <h2 className="card-title justify-center text-error mb-2">
              Something went wrong
            </h2>
            
            <p className="text-base-content/70 mb-4">
              We&apos;re sorry, but something unexpected happened.
            </p>

            <div className="card-actions justify-center gap-2">
              <button 
                onClick={reset}
                className="btn btn-primary btn-sm gap-2"
              >
                <FaRedo className="text-sm" />
                Try Again
              </button>
              
              <button 
                onClick={() => window.location.href = '/'}
                className="btn btn-outline btn-sm gap-2"
              >
                <FaHome className="text-sm" />
                Go Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
